import { actionTree } from "typed-vuex";
import { ActionContext } from "vuex";
import { RootState } from "..";
import getters from "./getters";
import mutations from "./mutations";
import state, { TabState } from "./state";
import { NavigationTab } from "~/types/types";

type Context = ActionContext<TabState, RootState>;

/**
 * Tab module actions.
 */
const actions = actionTree(
    { state, getters, mutations },
    {
        /**
         * Changes to a given tab.
         *
         * @param {Context} _
         * @param {NavigationTab} tab Tab to change to
         * @return {Promise<void>}
         */
        async changeTab(_: Context, tab: NavigationTab): Promise<void> {
            if (tab === NavigationTab.Dashboard) {
                const check = await this.app.$accessor.admin.check();
                if (!check) return;
            }

            this.app.$accessor.tab.setTab(tab);
        },
    },
);

export default actions;
